import { useIsComerciales } from '.';

export const useIsElectrico = (carlineName?: string) => {
	const isComerciales = useIsComerciales();

	if (!carlineName || typeof carlineName !== 'string') {
		return false;
	} else if (isComerciales) {
		return carlineName.substring(0, 3) === 'ID.' || carlineName.substring(0, 2) === 'e-';
	} else {
		return carlineName.substring(0, 3) === 'ID.';
	}
};
